import React from 'react';

const CardImage = ({ path, alt, size = 40 }) => {
  return <img src={path} alt={alt} width={size} height={size} />;
};

export default CardImage;